import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const filterSlice = createSlice({
  name: 'filter',
  initialState: {
    tags: [] as string[],
  },
  reducers: {
    addFilter: (state, action: PayloadAction<string>) => {
      if (!state.tags.includes(action.payload)) {
        state.tags.push(action.payload)
      }
    },
    removeFilter: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        tags: state.tags.filter(item => item !== action.payload),
      }
    },
    clearFilters: state => {
      return {
        ...state,
        tags: [],
      }
    },
  },
})

export const { addFilter, removeFilter, clearFilters } = filterSlice.actions

export const filterReducer = filterSlice.reducer
